import { Component, Input, OnInit } from '@angular/core';
import {
  faCircleNotch,
  faShieldHalved,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-authentication-cover',
  templateUrl: './authentication-cover.component.html',
  styleUrls: ['./authentication-cover.component.scss'],
})
export class AuthenticationCoverComponent implements OnInit {
  @Input() visible: boolean = true;
  @Input() appTitle: string = '';
  @Input() message: string = 'Authenticating';
  @Input() isAccessDenied = false;

  faCircleNotch = faCircleNotch;
  faShieldHalved = faShieldHalved;

  constructor() {}

  ngOnInit() {}
}
